export default {
	TEXT: 'text',
	IMAGE: 'image',
}
